export function createTalentTreeUrl(
  spellId: number,
  definitionId: number,
  invested: number,
  spellModifierId: number,
  abilityExternalSitePath?: string,
): string {
  return `${abilityExternalSitePath}${spellId}?def=${definitionId}&rank=${
    invested > 0 ? invested : 1 // default to 1 for wowhead to render the correct rank 1 tooltip as 0 is ignored
  }${spellModifierId ? `&spellModifier=${spellModifierId}` : ''}`;
}
